import { DataContext } from 'hooks/HeaderContext';
import React, { FC, useContext } from 'react';
import { FILTER_TYPE } from 'types/Dog';
import FilterBadge from './FilterBadge';


const FiltersAppliedPanel: FC = () => {

    const {
        removeAllFilters,
        selectedFilters,
        customView
    } = useContext(DataContext);

    const appliedFilters = Object.values(selectedFilters).flat().filter(opt => !customView || opt.type !== FILTER_TYPE.INSTITUTION);

    return (

        <div id="filterDiv" className="mb-3">
            Filters Applied
            <div className="d-flex mt-2 align-items-center pe-3" id="selectedFilters" >
                {(appliedFilters).map((filter) => (
                    < FilterBadge
                        filter={filter}
                        key={'filter-' + filter.type + '-' + filter.value}
                    />
                ))}
                <a className="ms-2 clearAllLnk fw-bold" onClick={removeAllFilters}>Clear All</a>
            </div>
        </div>
    )
}

export default FiltersAppliedPanel;




















